function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as c } from "react/jsx-runtime";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: e , size: r = 24  } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const a = n(), l = e !== null && e !== void 0 ? e : a ? o.colors.inverse : o.colors.neutralHigh;
    return /* @__PURE__ */ c("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ c("path", {
            fill: l,
            d: "M19.385 8.155a.62.62 0 00-.048-.244.846.846 0 00-.207-.38l-5.21-5.124a.862.862 0 00-.614-.252h-7.3c-.725 0-1.386.655-1.386 1.378v5.653l.042 7.977-.042 3.3c0 .737.653 1.378 1.387 1.378h11.991c.757 0 1.387-.633 1.387-1.378V8.155zm-1.194.868v11.44c0 .073-.086.163-.19.163H6.01c-.095 0-.19-.107-.19-.155l.042-3.3-.042-7.985V3.542c.006-.065.118-.171.19-.171h6.437v2.213c0 .997.334 1.857.98 2.49.628.624 1.491.95 2.494.95h2.272zm-6.336 7.208c.513 0 .91-.407.91-.942a.917.917 0 10-1.834 0v.017a.91.91 0 00.924.925zm1.787-12.407l4.048 3.98h-1.767c-.687 0-1.26-.21-1.667-.607-.406-.398-.614-.947-.614-1.613v-1.76zm2.23 11.465c0 .535-.397.942-.907.942a.91.91 0 01-.925-.925v-.017a.917.917 0 111.832 0zm-7.131.942c.518 0 .916-.407.916-.942a.918.918 0 00-.925-.932c-.51 0-.907.414-.907.932v.017c0 .518.397.925.916.925z"
        })
    }));
}, v = s;
export { v as default };
